/**
 * UsuariosPage — full-page route for /admin/usuarios.
 * Provides the paper background and centering shell; UsuariosTab owns the card.
 */
import { UsuariosTab } from "./UsuariosTab.js";

export function UsuariosPage() {
  return (
    <main className="min-h-full bg-[#f4f3ee] px-4 py-4 sm:px-8 sm:py-8 flex justify-center items-start">
      <UsuariosTab />
    </main>
  );
}
